export default __webpack_public_path__ + "static/media/createTeam.6d8b678c.svg";